import React from 'react';
import CenterListItem from "../../CenterListItem";
import {formatDate} from "../../../utils/date.utils";
import {useTranslation} from "react-i18next";
import CenterButton from "../../shared/button/CenterButton";

interface BlockFriendProps {
    id: string
    imgProfileURL: string
    name: string
    date: string
    onUnblock: (id: string) => void
}

export const BlockFriend: React.FunctionComponent<BlockFriendProps> = (props) => {
    const { t } = useTranslation();

    return (
        <CenterListItem
            avatarURL={props.imgProfileURL}
            title={props.name}
            description={formatDate(props.date)}
            avatarSize={48}
            tail={
                <CenterButton
                    small
                    onClick={() => {
                        props.onUnblock(props.id);
                    }}
                >
                    {t("Unblock")}
                </CenterButton>
            }
            itemStyle={{ border: 0}}
        />
    )
}